import React from 'react';
import ServiceAccessForm from '../../Shared/ServiceAccessForm/ServiceAccessForm';
import DeviceSupportsESIM from './Popups/DeviceSupportsESIM';
import SimNumberHelper from './Popups/SimNumberHelper';
import DeviceSupportsESIMCheckBox from './Popups/DeviceSupportsESIMCheckBox';
import PricePlanDetailsPopUp from './Popups/PricePlanDetailsPopUp';
import { PopupEnum } from './Constant/Constant';
import { connect } from 'react-redux';
import { setShowPopUp } from './TransferOrganizationAccountSlice';
import DeleteEsimPopUp from './Popups/DeleteEsimPopUp';
import { ServiceData } from './Constant/ServiceFormText';

const TransferOrganizationPopup = (props) => {
  let currentPopUp = () => {
    switch (props.currentPopUp) {
      case PopupEnum.ServiceFormPopup:
        return <ServiceAccessForm setShowPopUp={props.setShowPopUp} serviceData={ServiceData} />;
      case PopupEnum.DeviceSupportsESIM:
        return <DeviceSupportsESIM />;
      case PopupEnum.SimNumberHelper:
        return <SimNumberHelper />;
      case PopupEnum.DeviceSupportsESIMCheckBox:
        return <DeviceSupportsESIMCheckBox buttonClick={props.setShowPopUp} />;
      case PopupEnum.PricePlanDetailsPopUp:
        return <PricePlanDetailsPopUp />;
      case PopupEnum.DeleteEsimInstruction:
        return <DeleteEsimPopUp />;
      default:
        break;
    }
  };

  return <div>{currentPopUp()}</div>;
};
const mapStateToProps = (state) => ({
  currentPopUp: state.TransferOrganizationAccount.currentPopUp,
});

const mapDispatchToProps = { setShowPopUp };

export default connect(mapStateToProps, mapDispatchToProps)(TransferOrganizationPopup);
